import { Link } from 'react-router-dom';
import { Shield, Mail, Phone, MapPin } from 'lucide-react';

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#9B1B30]/10 rounded-full mb-4">
            <Shield className="w-8 h-8 text-[#9B1B30]" />
          </div>
          <h1 className="font-bold text-4xl text-gray-900 mb-3">
            Datenschutzerklärung
          </h1>
          <p className="text-gray-500">
            Letzte Aktualisierung: Januar 2025
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          {/* Verantwortlicher */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">1</span>
              Verantwortlicher
            </h2>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="font-semibold text-gray-900 mb-3">FarbWelt Maler Express Service UG (Haftungsbeschränkt)</p>
              <div className="space-y-2 text-gray-600">
                <p className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-[#9B1B30]" />
                  Gneisenaustr. 2, 41539 Dormagen
                </p>
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-[#9B1B30]" />
                  kontakt@farbwelt-service.de
                </p>
                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-[#9B1B30]" />
                  02133 7787688
                </p>
              </div>
            </div>
          </section>

          {/* Datenerhebung */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">2</span>
              Erhebung und Speicherung personenbezogener Daten
            </h2>
            <p className="text-gray-600 mb-4">
              Wenn Sie unsere Website besuchen, einen Termin buchen oder sich registrieren, erheben wir folgende Daten:
            </p>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-2">Bei Registrierung</h3>
                <ul className="text-gray-600 space-y-1 text-sm">
                  <li>• Vor- und Nachname</li>
                  <li>• E-Mail-Adresse</li>
                  <li>• Telefonnummer</li>
                  <li>• Anschrift (Straße, PLZ, Ort)</li>
                </ul>
              </div>
              <div className="bg-gray-50 rounded-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-2">Bei Terminbuchung</h3>
                <ul className="text-gray-600 space-y-1 text-sm">
                  <li>• Termindetails (Datum, Uhrzeit)</li>
                  <li>• Beschreibung des Anliegens</li>
                  <li>• Ihre Kundennummer</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Cookies */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">3</span>
              Cookies und Tracking
            </h2>
            <p className="text-gray-600 mb-4">
              Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden.
            </p>
            
            <div className="space-y-4">
              <div className="border border-gray-200 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <h3 className="font-semibold text-gray-900">Notwendige Cookies</h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Diese Cookies sind für den Betrieb der Website erforderlich. Sie ermöglichen grundlegende Funktionen 
                  wie die Anmeldung und den Zugriff auf geschützte Bereiche. Ohne diese Cookies kann die Website nicht 
                  ordnungsgemäß funktionieren.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                  <h3 className="font-semibold text-gray-900">Funktionale Cookies</h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Diese Cookies ermöglichen erweiterte Funktionen wie den Kundenservice-Chat und das Speichern 
                  Ihrer Präferenzen. Sie verbessern Ihre Benutzererfahrung.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                  <h3 className="font-semibold text-gray-900">Analyse-Cookies</h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Diese Cookies helfen uns zu verstehen, wie Besucher unsere Website nutzen. Die Informationen 
                  werden anonym erhoben und dienen der Verbesserung unserer Website.
                </p>
              </div>
            </div>
            
            <p className="text-gray-500 text-sm mt-4">
              Sie können Ihre Cookie-Einstellungen jederzeit über den Button in der Fußzeile ändern.
            </p>
          </section>

          {/* Zweck */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">4</span>
              Zweck der Datenverarbeitung
            </h2>
            <p className="text-gray-600 mb-4">
              Ihre Daten werden für folgende Zwecke verwendet:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                Durchführung und Verwaltung von Terminen
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                Kommunikation bezüglich Ihrer Anfragen und Termine
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                Erstellung von Angeboten und Rechnungen
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                Verbesserung unserer Dienstleistungen
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                Kundenservice und Support über unseren Chat
              </li>
            </ul>
          </section>

          {/* Rechtsgrundlage */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">5</span>
              Rechtsgrundlage
            </h2>
            <p className="text-gray-600">
              Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf folgenden Rechtsgrundlagen:
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                <span><strong>Art. 6 Abs. 1 lit. a DSGVO</strong> – Ihre Einwilligung (z.B. bei Cookies)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                <span><strong>Art. 6 Abs. 1 lit. b DSGVO</strong> – Vertragserfüllung (z.B. Terminbuchung)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#9B1B30] mt-1">•</span>
                <span><strong>Art. 6 Abs. 1 lit. f DSGVO</strong> – Berechtigte Interessen (z.B. Sicherheit)</span>
              </li>
            </ul>
          </section>

          {/* Speicherdauer */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">6</span>
              Datenspeicherung
            </h2>
            <p className="text-gray-600">
              Ihre Daten werden nur so lange gespeichert, wie es für die Erfüllung des Vertragszwecks 
              erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Nach Ablauf dieser 
              Fristen werden Ihre Daten routinemäßig gelöscht.
            </p>
            <div className="mt-4 bg-gray-50 rounded-xl p-4">
              <p className="text-sm text-gray-500">
                <strong>Hinweis:</strong> Buchhaltungsrelevante Daten werden gemäß HGB und AO für 
                10 Jahre aufbewahrt.
              </p>
            </div>
          </section>

          {/* Ihre Rechte */}
          <section className="p-8 border-b border-gray-100">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">7</span>
              Ihre Rechte
            </h2>
            <p className="text-gray-600 mb-4">
              Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
            </p>
            <div className="grid md:grid-cols-2 gap-3">
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Recht auf Auskunft</p>
                <p className="text-gray-500 text-xs">Art. 15 DSGVO</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Recht auf Berichtigung</p>
                <p className="text-gray-500 text-xs">Art. 16 DSGVO</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Recht auf Löschung</p>
                <p className="text-gray-500 text-xs">Art. 17 DSGVO</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Recht auf Einschränkung</p>
                <p className="text-gray-500 text-xs">Art. 18 DSGVO</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Recht auf Datenübertragbarkeit</p>
                <p className="text-gray-500 text-xs">Art. 20 DSGVO</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="font-medium text-gray-900 text-sm">Widerspruchsrecht</p>
                <p className="text-gray-500 text-xs">Art. 21 DSGVO</p>
              </div>
            </div>
          </section>

          {/* Kontakt */}
          <section className="p-8">
            <h2 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-[#9B1B30] text-white rounded-lg flex items-center justify-center text-sm">8</span>
              Kontakt
            </h2>
            <p className="text-gray-600 mb-4">
              Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten 
              oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:
            </p>
            <div className="bg-[#9B1B30]/5 border border-[#9B1B30]/20 rounded-xl p-6">
              <p className="font-semibold text-gray-900">FarbWelt Maler Express Service UG (Haftungsbeschränkt)</p>
              <p className="text-gray-600 mt-2">
                E-Mail: <a href="mailto:kontakt@farbwelt-service.de" className="text-[#9B1B30] hover:underline">kontakt@farbwelt-service.de</a><br />
                Telefon: 02133 7787688
              </p>
            </div>
            <p className="text-gray-500 text-sm mt-4">
              Sie haben auch das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die 
              Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
            </p>
          </section>
        </div>

        {/* Back Link */}
        <div className="text-center mt-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#9B1B30] hover:underline"
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
